import apiService from "./api";

const paymentService = {
    // Get order group by user ID
    getOrderGroupByUser(userId, params) {
        return apiService.get(`/payment/order-group/user/${userId}`, params);
    },
    // Process order takeover/payment
    processOrderTakeOver(data) {
        return apiService.post("/payment/take-over", data);
    },
    // Get user data for payment (supports group and regular company types)
    getUserData(userId, params, isGroup = false) {
        const endpoint = isGroup ? `/user/${userId}/group` : `/user/${userId}`;
        return apiService.get(endpoint, params);
    },
    // Set reserved meal/food order
    setReservedOrder(data, isGroup = false) {
        const endpoint = isGroup ? "/orders/set-reserved-food" : "/orders/set-reserved-meal";
        return apiService.post(endpoint, data);
    },
};

export default paymentService;
